import type {
  ExpenseByIdQuery,
  UpdateExpenseItemInput,
} from '../../../__generated__/graphql';
import { ExpenseRecordType, ExpenseItemRecordType } from '../types';
import {
  GeocoderService,
  type GeocodeCallback,
} from '../../../../../components/GoogleMapsRoute';

export const MILEAGE_RECORD_TYPE_KEY = ExpenseRecordType.Mileage;

export const TRAVEL_RECORD_TYPE_DEVELOPER_NAME = ExpenseItemRecordType.Travel;

export const GEOCODE_DEBOUNCE_DELAY = 1000;

export const ADDRESS_UPDATE_DEBOUNCE_DELAY = 800;

export const POLLING_INTERVAL = 3000;

export const AUTO_SAVE_DELAY = 800;

export type MileageFormData = {
  description: string;
  expenseDate: Date;
  expenseGroupId: string;
  projectId: string;
  categoryId: string;
  merchantId: string;
  merchantName?: string;
};

export const mapExpenseToFormData = (
  expense: NonNullable<ExpenseByIdQuery['expense']>,
): MileageFormData => ({
  description: expense.flair__Description__c || '',
  expenseDate: expense.flair__Date_From__c
    ? new Date(expense.flair__Date_From__c)
    : new Date(),
  expenseGroupId: expense.flair__Expense_Group__c || '',
  projectId: expense.project?.Id || '',
  categoryId: expense.expenseCategory?.Id || '',
  merchantId: expense.merchant?.Id || '',
  merchantName: expense.merchant?.Name || '',
});

export const findTravelExpenseItem = (
  expenseItems:
    | NonNullable<ExpenseByIdQuery['expense']>['expenseItems']
    | null
    | undefined,
):
  | NonNullable<ExpenseByIdQuery['expense']>['expenseItems'][number]
  | undefined => {
  return expenseItems?.find(
    (item) =>
      item.recordType?.DeveloperName === TRAVEL_RECORD_TYPE_DEVELOPER_NAME,
  );
};

const geocoderService = new GeocoderService();

export const geocodeAddressHelper = (
  address: string,
  type: 'start' | 'end',
  callback: GeocodeCallback,
): void => {
  geocoderService.geocode(address, type, callback);
};

export const buildAddressUpdateInput = (
  travelExpenseItemId: string,
  addressFrom: string,
  addressTo: string,
): UpdateExpenseItemInput =>
  ({
    id: travelExpenseItemId,
    flair__Address_From__c: addressFrom || null,
    flair__Address_To__c: addressTo || null,
    RecordTypeId: null,
    flair__Manual_Amount__c: null,
    extraFields: [],
  } as Partial<UpdateExpenseItemInput> as UpdateExpenseItemInput);
